/**
 * Whether the user has typed the device id exactly (ignoring surrounding
 * whitespace), gating the destructive delete the way S3 gates bucket deletion.
 * Case-sensitive: unlike custom-field names, device ids are caller-chosen at
 * registration and may carry mixed case, so a loose match would let the user
 * confirm a device other than the one they are looking at.
 */
export function isDeleteConfirmed(typed: string, deviceId: string): boolean {
  return typed.trim() === deviceId;
}
